import { generateKeys } from '../utils';
export const wallettecPaymentMethods = generateKeys({
    gh: {
        label: 'MTN/AirtelTigo/Vodafone',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'MTN',
                value: 'mtn',
                key: 'mtn',
            },
            {
                label: 'AirtelTigo',
                value: 'airteltigo',
                key: 'airteltigo',
            },
            {
                label: 'Vodafone',
                value: 'vodafone',
                key: 'vodafone',
            },
        ],
    },
    ug: {
        label: 'AirTel/MTN',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'AirTel',
                value: 'airtel',
                key: 'airtel',
            },
            {
                label: 'MTN',
                value: 'mtn',
                key: 'mtn',
            },
        ],
    },
    ke: {
        label: 'M-Pesa',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'M-Pesa',
                value: 'mpesa',
                key: 'mpesa',
            },
        ],
    },
    tz: {
        label: 'Airtel/Hellopaisa/Tigo/Vodafone',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'Airtel',
                value: 'airtel',
                key: 'airtel',
            },
            {
                label: 'Hellopaisa',
                value: 'hellopaisa',
                key: 'hellopaisa',
            },
            {
                label: 'Tigo',
                value: 'tigo',
                key: 'tigo',
            },
            {
                label: 'Vodafone',
                value: 'vodafone',
                key: 'vodafone',
            },
        ],
    },
    zm: {
        label: 'MTN/Airtel/Zamtel',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'MTN',
                value: 'mtn',
                key: 'mtn',
            },
            {
                label: 'Airtel',
                value: 'airtel',
                key: 'airtel',
            },
            {
                label: 'Zamtel',
                value: 'zamtel',
                key: 'zamtel',
            },
        ],
    },
    rw: {
        label: 'Airtel/MTN',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'Airtel',
                value: 'airtel',
                key: 'airtel',
            },
            {
                label: 'MTN',
                value: 'mtn',
                key: 'mtn',
            },
        ],
    },
    cm: {
        label: 'MTN/Orange',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'MTN',
                value: 'mtn',
                key: 'mtn',
            },
            {
                label: 'Orange',
                value: 'orange',
                key: 'orange',
            },
        ],
    },
    za: {
        label: 'Ozow/Snapscan',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'Ozow',
                value: 'ozow',
                key: 'ozow',
            },
            {
                label: 'Snapscan',
                value: 'snapscan',
                key: 'snapscan',
            },
        ],
    },
    ng: {
        label: 'Nigeria Instant Bank Payment',
        localization: { id: '', defaultMessage: '' },
        options: [
            {
                label: 'Nigeria Instant Bank Payment',
                value: 'nigeriaInstantBankPayment',
                key: 'nigeriaInstantBankPayment',
            },
        ],
    },
});
